<template>
  <div class="mall-h5">
    <div class="mh5-result">
      <!-- 状态图标 -->
      <div class="mh5-result__icon" :class="iconClass">
        <van-icon :name="iconName" />
      </div>

      <!-- 状态文案 -->
      <div class="mh5-result__text">{{ statusText }}</div>
      <div class="mh5-result__sub" v-if="orderNo">订单号：{{ orderNo }}</div>

      <!-- 状态提示 -->
      <div class="mh5-result__hint" v-if="status === 'polling'">
        正在确认支付结果，请稍候...
      </div>
      <div class="mh5-result__hint" v-if="status === 'fail'">
        如已支付成功，请联系客服确认
      </div>
      <div class="mh5-result__hint" v-if="status === 'timeout'">
        如已扣款，请稍后在订单中查看
      </div>

      <!-- 订单详情卡片 -->
      <div class="mh5-result__order" v-if="order">
        <div class="mh5-result__order-head">订单详情</div>
        <div class="mh5-result__row">
          <span>订单金额</span>
          <span class="mh5-price">¥{{ order.totalAmount }}</span>
        </div>
        <div class="mh5-result__row" v-if="order.receiverName || order.receiverPhone">
          <span>收货人</span>
          <span>{{ order.receiverName }} {{ order.receiverPhone }}</span>
        </div>
        <div class="mh5-result__row" v-if="formatAddress(order)">
          <span>收货地址</span>
          <span>{{ formatAddress(order) }}</span>
        </div>
        <div class="mh5-result__row" v-if="order.orderStatus === 2 && order.expressNo">
          <span>快递单号</span>
          <span class="mh5-result__express">{{ order.expressNo }}</span>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="mh5-result__btns">
        <template v-if="status === 'timeout'">
          <div class="mh5-btn-ghost" @click="goOrderDetail">查看订单</div>
          <div class="mh5-btn-primary" @click="recheck">重新查询</div>
        </template>
        <template v-else>
          <div class="mh5-btn-ghost" @click="goList">继续购物</div>
          <div v-if="orderNo" class="mh5-btn-primary" @click="goOrderDetail">查看订单</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mallH5SelectPayState, mallH5OrderDetail } from '@/api/mall'
import { restoreMallCtx, withCtx } from './mallCtx'

export default {
  name: 'MallH5PayResult',
  data() {
    return {
      orderNo: '',
      pollCount: 0,
      maxPoll: 10,
      interval: 5000,
      timer: null,
      order: null,
      status: 'polling'
    }
  },
  computed: {
    iconClass() {
      return { polling: 'is-polling', success: 'is-success', fail: 'is-fail', timeout: 'is-timeout' }[this.status]
    },
    iconName() {
      return { polling: 'loading', success: 'checked', fail: 'close', timeout: 'warning-o' }[this.status]
    },
    statusText() {
      return { polling: '支付进行中', success: '支付成功', fail: '支付未完成', timeout: '支付结果确认中' }[this.status]
    }
  },
  created() {
    restoreMallCtx(this.$route)
    this.orderNo = this.$route.query.orderNo
    this.startPoll()
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer)
  },
  methods: {
    startPoll() {
      this.poll()
    },
    async poll() {
      if (!this.orderNo) return
      this.pollCount++
      // 第3次与最后一次主动查微信(触发补单)，其余仅查本地
      const end = this.pollCount === 3 || this.pollCount >= this.maxPoll
      try {
        const res = await mallH5SelectPayState(this.orderNo, end)
        const tradeState = res.data && res.data.tradeState
        if (tradeState === 'SUCCESS') {
          this.status = 'success'
          this.fetchOrder()
          return
        }
        if (tradeState === 'PAY_CLOSED' || tradeState === 'PAYERROR') {
          this.status = 'fail'
          return
        }
        // PAY_USERPAYING 或未知状态：继续轮询
        this.scheduleNext()
      } catch (e) {
        // 接口异常：容错继续轮询，不直接判失败
        this.scheduleNext()
      }
    },
    scheduleNext() {
      if (this.pollCount < this.maxPoll) {
        this.timer = setTimeout(() => this.poll(), this.interval)
      } else {
        this.status = 'timeout'
      }
    },
    recheck() {
      if (this.timer) clearTimeout(this.timer)
      this.pollCount = 0
      this.status = 'polling'
      this.startPoll()
    },
    async fetchOrder() {
      try {
        const res = await mallH5OrderDetail(this.orderNo)
        this.order = res.data
      } catch (e) { /* ignore */ }
    },
    formatAddress(o) {
      return [o.receiverProvince, o.receiverAddress].filter(Boolean).join('')
    },
    goList() { this.$router.replace({ path: '/h5/mall/list', query: withCtx() }) },
    goOrderDetail() {
      // 跳转到订单查询页(免登录,按收货手机号查询订单)
      window.location.href = window.location.origin + (process.env.BASE_URL || '/') + 'h5/mall/inquiry'
    }
  }
}
</script>

<style scoped>
/* ===== 全局基调 ===== */
.mall-h5 {
  min-height: 100vh;
  background: #F8F4F0;
  -webkit-font-smoothing: antialiased;
}

/* ===== 结果页主体 ===== */
.mh5-result {
  padding: 60px 20px 40px;
  text-align: center;
}

/* 状态图标 */
.mh5-result__icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #fff;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}
.mh5-result__icon .van-icon {
  font-size: inherit;
  color: inherit;
}
.mh5-result__icon.is-polling {
  background: linear-gradient(135deg, #409eff, #337ecc);
  animation: pulse 1.5s ease-in-out infinite;
}
.mh5-result__icon.is-success {
  background: linear-gradient(135deg, #52c41a, #3da012);
}
.mh5-result__icon.is-fail {
  background: linear-gradient(135deg, #B0A89E, #999);
}
.mh5-result__icon.is-timeout {
  background: linear-gradient(135deg, #E6A23C, #CF8A2E);
}

@keyframes pulse {
  0%, 100% { box-shadow: 0 8px 24px rgba(64,158,255,0.2); }
  50% { box-shadow: 0 8px 36px rgba(64,158,255,0.4); }
}

/* 状态文案 */
.mh5-result__text {
  font-size: 20px;
  font-weight: 600;
  color: #3C3C3C;
  margin-bottom: 8px;
}
.mh5-result__sub {
  font-size: 14px;
  color: #B0A89E;
  margin-bottom: 4px;
}
.mh5-result__hint {
  font-size: 13px;
  color: #C9A96E;
  margin-top: 8px;
}

/* 订单详情卡片 */
.mh5-result__order {
  background: #fff;
  border-radius: 14px;
  margin: 28px 0;
  padding: 16px;
  text-align: left;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}
.mh5-result__order-head {
  font-size: 16px;
  font-weight: 600;
  color: #3C3C3C;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #F0ECE6;
}
.mh5-result__row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 14px;
}
.mh5-result__row + .mh5-result__row {
  border-top: 1px solid #F8F4F0;
}
.mh5-result__row span:first-child {
  color: #B0A89E;
  flex-shrink: 0;
}
.mh5-result__row span:last-child {
  color: #3C3C3C;
  text-align: right;
  max-width: 62%;
  word-break: break-all;
}
.mh5-price {
  color: #C0392B;
  font-weight: 600;
}
.mh5-result__express {
  color: #C9A96E !important;
  font-weight: 500;
}

/* 操作按钮 */
.mh5-result__btns {
  display: flex;
  gap: 12px;
  padding: 0 4px;
}
.mh5-btn-ghost {
  flex: 1;
  height: 44px;
  line-height: 44px;
  border: 1px solid #C0392B;
  color: #C0392B;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.mh5-btn-ghost:active {
  background: rgba(192,57,43,0.05);
}
.mh5-btn-primary {
  flex: 1;
  height: 44px;
  line-height: 44px;
  background: linear-gradient(135deg, #C0392B, #A3312A);
  color: #fff;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(192,57,43,0.25);
  cursor: pointer;
  transition: opacity 0.2s;
}
.mh5-btn-primary:active {
  opacity: 0.9;
}
</style>
